import { z } from "zod";
import { validarCpfCnpj } from "../../../../util/documento";
import { onlyNumbers } from "../../../../util/libString";

const soDigitos = (valor) => onlyNumbers(String(valor ?? ""));

export const schema = z.object({
	// Emitente
	cnpj: z
		.string()
		.min(1, "Preencha o CNPJ")
		.refine(validarCpfCnpj, "CNPJ inválido"),
	ie: z.string().max(20),
	razao_social: z.string().max(100).min(1, "Preencha a razão social"),
	fantasia: z.string().max(100),
	telefone: z
		.string()
		.refine((v) => v === "" || [10, 11].includes(soDigitos(v).length), "Telefone inválido"),

	cep: z
		.string()
		.min(1, "Preencha o CEP")
		.refine((v) => soDigitos(v).length === 8, "CEP deve ter 8 dígitos"),
	rua: z.string().max(100).min(1, "Preencha o logradouro"),
	numero: z.string().max(100).min(1, "Preencha o número"),
	complemento: z.string().max(100),
	bairro: z.string().max(100).min(1, "Preencha o bairro"),

	// Codigo IBGE do municipio. Vai no cMun da nota - errado, a SEFAZ rejeita.
	cod_cidade: z
		.string()
		.min(1, "Preencha o código IBGE")
		.refine((v) => soDigitos(v).length === 7, "O código IBGE tem 7 dígitos"),
	cidade: z.string().max(100).min(1, "Preencha a cidade"),
	uf: z.string().length(2, "Use a sigla com 2 letras"),

	crt: z.coerce.number().int().min(1, "Selecione o regime").max(3),

	// Documento
	ambiente: z.string().max(12),
	serie: z.coerce.number().int().min(1, "Série mínima 1").max(999, "Série máxima 999"),

	// Codigo de Seguranca do Contribuinte. Sem ele o QR Code da NFC-e nao valida.
	csc: z.string().max(50),
	id_csc: z.string().max(10),
	timeout: z.coerce.number().int().min(1000, "Mínimo 1000 ms").max(120000),

	// Impostos - usados quando o produto nao tem o proprio
	cfop_padrao: z.string().length(4, "CFOP tem 4 dígitos").regex(/^\d+$/, "Só números"),
	csosn_padrao: z.string().max(4),
	cst_padrao: z.string().max(3),
	icms_padrao: z.coerce.number().min(0).max(100, "Máximo 100%"),
	ncm_padrao: z
		.string()
		.refine((v) => v === "" || soDigitos(v).length === 8, "O NCM tem 8 dígitos"),
	cest_padrao: z
		.string()
		.refine((v) => v === "" || soDigitos(v).length === 7, "O CEST tem 7 dígitos"),

	// IBS/CBS - NT 2025.002. Vazio desliga o grupo na nota.
	cst_ibscbs_padrao: z.string().max(3),
	cclasstrib_padrao: z.string().max(10),
	pibsuf: z.coerce.number().min(0).max(100),
	pibsmun: z.coerce.number().min(0).max(100),
	pcbs: z.coerce.number().min(0).max(100),
});

export const schemaCertificado = z.object({
	senha: z.string().min(1, "Informe a senha do certificado"),
});
